module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_text.1787648603550.png";